<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import BenefitsGridSection from "./BenefitsGridSection.svelte";
	import translations from "./GiftSubscriptionAdvantagesSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const benefits = [
		{ title: translate("benefit1Title"), description: translate("benefit1Description") },
		{ title: translate("benefit2Title"), description: translate("benefit2Description") },
		{ title: translate("benefit3Title"), description: translate("benefit3Description") },
		{ title: translate("benefit4Title"), description: translate("benefit4Description") },
		{ title: translate("benefit5Title"), description: translate("benefit5Description") },
		{ title: translate("benefit6Title"), description: translate("benefit6Description") },
		{ title: translate("benefit7Title"), description: translate("benefit7Description") },
		{ title: translate("benefit8Title"), description: translate("benefit8Description") },
		{ title: translate("benefit9Title"), description: translate("benefit9Description") },
	];
</script>

<BenefitsGridSection
	section={translate("section")}
	sectionClass="bg-fcrlinen"
	captionClass="text-white"
	title={translate("title")}
	cardClass="bg-white"
	cardSizeClass="w-88 h-46"
	cards={benefits.map((benefit) => ({
		...benefit,
		headingClass: "text-fcrorange",
		textClass: "text-fcrdarkgray",
	}))}
/>
